import { IEmpresas } from '@/types';
import { MutationTree } from 'vuex';
import { DashboardState, IDashboard, IBDashboard, IFiltroLocal, ILayout, DashboardMutations } from './types';

export const mutations: MutationTree<DashboardState> = {
  [DashboardMutations.ATUALIZAR_LISTA_DASHBOARD](state, payload: IDashboard[]) {
    state.dashboardList = payload;
  },
  [DashboardMutations.OPEN_EDITOR_MODE](state) {
    state.isEditorMode = true;
  },
  [DashboardMutations.CLOSE_EDITOR_MODE](state) {
    state.isEditorMode = false;
    state.isEditar = false;
  },
  [DashboardMutations.ATUALIZAR_GRID_LAYOUT_EDITOR](state, payload: ILayout[]) {
    state.gridLayoutEditor = payload;
  },
  [DashboardMutations.ATUALIZAR_NOME_DASHBOARD_ATUAL](state, payload: string) {
    state.currentDashboardName = payload;
  },
  [DashboardMutations.ATUALIZAR_DASHBOARD_SELECIONADA](state, payload: string) {
    state.currentDash = payload;
  },
  [DashboardMutations.ATUALIZAR_LISTA_EMPRESAS_OPTIONS](state, payload: IEmpresas[]) {
    state.empresasOptions = payload;
  },
  [DashboardMutations.ATUALIZAR_LISTA_FILTROS_LOCAIS_PREENCHIDOS](state, payload: IFiltroLocal[]) {
    state.filtrosLocaisPreenchidos = payload;
  },
  [DashboardMutations.ATUALIZAR_LISTA_MODIFICACOES_DASHBOARD](state, payload) {
    // @ts-ignore
    state.modificationDashboard = payload;
  },
  [DashboardMutations.ATUALIZAR_LISTA_MODIFICACOES_DASHBOARD_ITENS](state, payload) {
    // @ts-ignore
    state.modificationItens = payload;
  },
  [DashboardMutations.ATUALIZAR_IS_EDITAR](state, payload:boolean = true) {
    state.isEditar = payload;
  },
  [DashboardMutations.LIMPAR_LISTA_MODIFICACOES](state) {
    // @ts-ignore
    state.modificationItens = [];
    // @ts-ignore
    state.modificationDashboard = [];
  },
  [DashboardMutations.LISTA_INICIAL](state, payload:IBDashboard[]) {
    const displayInfos = payload.map(dashboards => {
      const { isDefaultDashboard, isSelectedToViewByDefault } = dashboards;
      const loadLayout = (isDefaultDashboard || isSelectedToViewByDefault);
      return {
        title: dashboards.dashboardName,
        key: dashboards.dashboardId,
        layout: loadLayout ? dashboards.layout : [],
        isDefault: dashboards.isSelectedToViewByDefault,
        isDefaultDashboard: dashboards.isDefaultDashboard,
        isSelectedToViewByDefault: dashboards.isSelectedToViewByDefault,
        rolesAuthorizedToView: dashboards.rolesAuthorizedToView,
        rolesAuthorizedToEdit: dashboards.rolesAuthorizedToEdit,
        userRoleId: dashboards.userRoleId,
        userId: dashboards.userId,
        isLoggedUserAuthor: dashboards.isLoggedUserAuthor
      };
    });

    const initialDashboardList = displayInfos;
    state.dashboardList = initialDashboardList;
  },
  [DashboardMutations.ATUALIZAR_LAYOUT](state, { id, layout }) {
    const newLayouts = state.dashboardList.map(dash => {
      if (dash.key === id) {
        dash.layout = layout;
      }
      return dash;
    });

    state.dashboardList = newLayouts;
  },
  [DashboardMutations.ATUALIZAR_LISTA_APOS_EXCLUIR](state, { id }) {
    const newDashboardList = state.dashboardList
      .filter(dashboard => dashboard.key !== id);
    state.dashboardList = newDashboardList;
  },
  [DashboardMutations.ATUALIZAR_TIPO_DE_DOCUMENTO](state, documentos) {
    state.tipoDeDocumento = documentos;
  },
  [DashboardMutations.SALVAR_SHORTCUTDATAS](state, datas) {
    state.shotcutDate = datas;
  }
};
